import { EventEmitter } from "events";
import Logger from "../../clients/logger";

/**
 *SocketConnection is a wrapper around websocket the allows us to emit events and handles the basic connection functions
 *
 * @export
 * @class SocketConnection
 * @extends {EventEmitter}
 */
export default class SocketConnection extends EventEmitter {
	ws: WebSocket | null;

	port: number;

	wsConnectionFailureTimeout: number | undefined;

	constructor(port?: number) {
		super();
		this.ws = null;
		this.port = port || 8392;
	}

	/**
	 *Connect to a websocket
	 *
	 * @returns
	 * @memberof SocketConnection
	 */
	connect() {
		if (this.ws && (this.ws.readyState === 0 || this.ws.readyState === 1)) return; // If we're connected don't try to connect again

		if (this.ws && this.ws.readyState === 2) {
			// if the socket is closing, wait for the ws to be closed before trying to reconnect
			const timeout = setTimeout(() => {
				clearTimeout(timeout);
				this.connect();
			}, 1000);
			return;
		}
		Logger.system.debug("Assimilation connecting to :", `ws://127.0.0.1:${this.port}`);
		const ws = (this.ws = new WebSocket(`ws://127.0.0.1:${this.port}`));
		// Called when the socket connection is open
		ws.onopen = () => {
			Logger.system.debug("Assimilation connected to socket");
			this.emit("socketOpen");
		};
		// Called when there is a socket error
		ws.onerror = (err) => {
			this.emit("socketError", err);
		};

		// This is called when the websocket receives a message. This looks for a topic and emits the topic with the data
		ws.onmessage = (msg) => {
			// All messages come in here
			let parsedMessage;
			try {
				parsedMessage = JSON.parse(msg.data);
				if (!parsedMessage.topic) {
					return;
				}
				return this.emit(parsedMessage.topic, parsedMessage);
			} catch (err) {
				Logger.system.error("Assimilation:Socket.onMessage:err:", err, msg);
			}
		};
		// Emit a socketClosed event when the socket is closed
		ws.onclose = () => {
			this.emit("socketClosed");
			Logger.system.log("SERVICE LIFECYCLE:Web socket closed");
		};
	}

	/**
	 *send data through the websocket
	 *
	 * @param {*} data
	 * @memberof SocketConnection
	 */
	send(data: string | ArrayBufferLike | Blob | ArrayBufferView) {
		// try to connect if completely disconnected
		if (!this.ws || this.ws.readyState > 1) {
			this.connect();
		}
		// wait for open if not connected
		if (!this.ws || this.ws.readyState !== 1) {
			this.on("socketOpen", () => this.send(data));
			return;
		}

		this.ws.send(data);
	}
}
